import Head from "next/head";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Header from "@/components/common/Header";
import CookieBanner from "@/components/CookieBanner";
import GuruWizard from "@/components/wizard/GuruWizard";

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

export default function GuruPage() {
  const metaTitle = "Fotobox-Finder – Finde deine perfekte Fotobox";
  const metaDesc =
    "Beantworte ein paar Fragen – wir schlagen dir passende Fotoboxen vor.";

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="robots" content="noindex, nofollow" />

        <link rel="icon" href="/fav/favicon.ico" type="image/x-icon" />
      </Head>

      <div className="bg-[#F9F9F9] flex flex-col">
        <Header sticky={false} />

        <main className="flex-1 mx-auto px-4 py-8 sm:px-6 max-w-7xl lg:px-8 lg:py-12 w-full min-h-screen">
          <GuruWizard />
        </main>
      </div>

      <CookieBanner />
    </>
  );
}
